import React from "react";
import { Route, Router, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import cx from "classnames";
import { setMobileNavVisibility } from "../../reducers/Layout";
import { withRouter } from "react-router-dom";

import Header from "./Header";
import Footer from "./Footer";
import SideBar from "../../components/SideBar";
/**
 * Pages
 */

import Car from "../CAR";
import CapitalPlanning from "../CapitalPlanning";
import Icaap from "../ICAAP";
import User from "../User";
import Role from "../Role";
import UserProfile from "../UserProfile";
import Dashboard from "../Dashboard";
import Activities from "../Activities";
import ConfigParamaters from "../Config";
import MasterTable from "../MasterTable";
import Raroc from "../Raroc";
import Pricing from "../Pricing";
import UploadValidate from "../UploadValidate";
import ReportPermission from "../ReportPermission";

const Main = ({ mobileNavVisibility, hideMobileMenu, history }) => {
  history.listen(() => {
    if (mobileNavVisibility === true) {
      hideMobileMenu();
    }
  });
  return (
    <div
      className={cx({
        "nav-open": mobileNavVisibility === true,
      })}
    >
      <div className="wrapper">
        <div className="close-layer" onClick={hideMobileMenu}></div>
        <SideBar backgroundImage="../../assets/icons/EY-logo.png" />

        <div className="main-panel">
          <Header />
          <Route path="/car" component={Car} />
          <Route path="/capital-planning" component={CapitalPlanning} />
          <Route path="/icaap" component={Icaap} />
          <Route path="/master-table" component={MasterTable} />
          <Route path="/config" component={ConfigParamaters} />
          <Route path="/user" component={User} />
          <Route path="/role" component={Role} />
          <Route path="/activities" component={Activities} />
          <Route path="/dashboard" component={Dashboard} />
          {/* <Route path="/config-risk-weight" component={ConfigSRW} /> */}
          {/* <Route path="/profile" component={UserProfile} /> */}
          <Route path="/raroc" component={Raroc} />
          <Route path="/pricing" component={Pricing} />
          <Route path="/validate-result" component={UploadValidate} />
          <Route path="/report-permission" component={ReportPermission} />
          <Route exact path="/" render={() => <Redirect to="/dashboard" />} />
          <Footer />
        </div>
      </div>
    </div>
  );
};

const mapStateToProp = (state) => ({
  mobileNavVisibility: state.Layout.mobileNavVisibility,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  hideMobileMenu: () => dispatch(setMobileNavVisibility(false)),
});

export default withRouter(connect(mapStateToProp, mapDispatchToProps)(Main));



// WEBPACK FOOTER //
// src/pages/Main/index.js